/**
 * International-friendly passport / travel document number validation (typed by users).
 * Allows 5–15 letters and digits (covers many countries; Indian format remains valid).
 */
export const PASSPORT_NUMBER_REGEX = /^[A-Z0-9]{5,15}$/;

export const PASSPORT_FORMAT_MESSAGE =
  'Passport number must be 5–15 letters or digits only (no spaces).';

/** Strip spaces/dashes and uppercase; keeps A–Z and 0–9 only */
export function normalizePassportInput(value) {
  return String(value || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}

export function isValidPassportNumber(value) {
  const s = normalizePassportInput(value);
  return PASSPORT_NUMBER_REGEX.test(s);
}
